// extracted by mini-css-extract-plugin
export default {"wrapper":"XB-z","viewport":"YB-z","container":"ZB-z","slide":"_B-z"};